export function maskLast4(last4: string) {
  const maskPrefix = '*';
  return `${maskPrefix}${last4}`;
}
